import { Button, Card, Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

const PipelineServicesModal = (props) => {
  const { t } = useTranslation();
  const title = t('pipelineServices');

  return (
    <Modal
      {...props}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="h1">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t('pipelineModalDesc')}</p>
        <Card className="px-4">
          <ul>
            <li>{t('pipelineService1')}</li>
            <li>{t('pipelineService2')}</li>
            <li>{t('pipelineService3')}</li>
            <li>{t('pipelineService4')}</li>
            <li>{t('pipelineService5')}</li>
          </ul>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => props.onHide(title)}>{t('getQuote')}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PipelineServicesModal;
